import Request from "../utils/request";

import { ipUrl } from "./index";

/****************************************套餐管理************************************************* */

// 条件查询套餐
export function findAll(data) {
  return Request({
    url: `${ipUrl}package/findAll`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}

// //根据订单号查询套餐
// export function getPackagesByOid(data){
//     return Request({
//         url: `${ipUrl}api/package/getPackagesByOid`,
//         method: 'post',
//         data: data
//     })
// }

//根据订单号查询套餐
export function getPackagesByOid(data) {
  return Request({
    url: `${ipUrl}order/pInfo`,
    method: "post",
    data: data,
    headers: {
      customerId: JSON.parse(window.sessionStorage.getItem("user")).customer_id
    }
  });
}



// WEBPACK FOOTER //
// ./src/service3/packageController.js